export { default } from "components/Organisms/DatasetsMenu/DatabaseDropdown/DropdownLabel/DropdownLabel";
